export default __webpack_public_path__ + "static/media/WINE3.6f1e4971.jpg";